import { render, staticRenderFns } from "./ModalSubBukuBesarBulan.vue?vue&type=template&id=52c6dd72"
import script from "./ModalSubBukuBesarBulan.vue?vue&type=script&lang=js"
export * from "./ModalSubBukuBesarBulan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports